import "../styles/adminContactStyles.css";
const ContactSummary = ({ summary, onStatusClick }) => {
  return (
    <div className="row" style={{marginTop:'20px'}}>
      <div className="col-sm-2">
        <label>Total Contacts:</label>
        <span
          className="summary-link"
          onClick={() => onStatusClick(0)}
        >
          {summary[0].totalRecords}
        </span>
      </div>

      <div className="col-sm-2">
        <label>Pending Invite:</label>
        <span
          className="summary-link"
          onClick={() => onStatusClick(3)}
        >
          {summary[0].pendingInvite}
        </span>
      </div>

      <div className="col-sm-2">
        <label>Pending Login:</label>
        <span
          className="summary-link"
          onClick={() => onStatusClick(4)}
        >
          {summary[0].pendingLogin}
        </span>
      </div>

      <div className="col-sm-2">
        <label>Active:</label>
        <span
          className="summary-link"
          onClick={() => onStatusClick(1)}
        >
          {summary[0].activeCount}
        </span>
      </div>

      <div className="col-sm-2">
        <label>In Active:</label>
        <span
          className="summary-link"
          onClick={() => onStatusClick(2)}
        >
          {summary[0].inActiveCount}
        </span>
      </div>
    </div>
  );
};

export default ContactSummary;